export const ffSectionId = 'following_followers';
export const blogSectionId = 'blog';
export const myAccountPageId = 'member_info';
export const aboutPageId = 'about';
